@if (useList) {
  <ul [attr.role]="nestedList ? 'group' : 'tree'" [attr.aria-labelledby]="ariaLabelledBy" class="list-unstyled m-0">
    @for (panel of panels; track panel.id) {
      <li [attr.aria-expanded]="panel.isOpen" role="treeitem">
        <div id="{{ panel.id }}-header" class="lap-accordion-header">
          <ng-template
            [ngTemplateOutlet]="panel.headerTpl?.templateRef"
            [ngTemplateOutletContext]="{ $implicit: panel, opened: panel.isOpen }"
          ></ng-template>
        </div>
        @if (panel.isOpen) {
          <ul
            id="{{ panel.id }}"
            role="group"
            class="list-unstyled m-0 lap-accordion-body"
            [attr.aria-labelledby]="panel.id + '-header'"
          >
            @if (!nestedList) {
              <li role="treeitem">
                <ng-container *ngTemplateOutlet="item"></ng-container>
              </li>
            } @else {
              <ng-template [ngTemplateOutlet]="panel.contentTpl?.templateRef || null"></ng-template>
            }
            <ng-template #item>
              <ng-template [ngTemplateOutlet]="panel.contentTpl?.templateRef || null"></ng-template>
            </ng-template>
          </ul>
        }
      </li>
    }
  </ul>
} @else {
  @for (panel of panels; track panel.id) {
    <div>
      <div id="{{ panel.id }}-header" class="lap-accordion-header">
        <ng-template
          [ngTemplateOutlet]="panel.headerTpl?.templateRef"
          [ngTemplateOutletContext]="{ $implicit: panel, opened: panel.isOpen }"
        ></ng-template>
      </div>
      @if (panel.isOpen) {
        <div id="{{ panel.id }}" role="tabpanel" [attr.aria-labelledby]="panel.id + '-header'">
          <div class="lap-accordion-body">
            <ng-template [ngTemplateOutlet]="panel.contentTpl?.templateRef || null"></ng-template>
          </div>
        </div>
      }
    </div>
  }
}
